import { PaymentDeliveryMethodType } from '@routable/shared';
import {} from 'interfaces/item';
import { filterPaymentDeliveryOptions } from './paymentMethods';
export const hasConversion = (item) => item.isInternational && item.currencyCodeReceiver !== item.currencyCodeCompany;
export const getConversionCurrency = (item) => item.currencyCode === item.currencyCodeReceiver ? item.currencyCodeCompany : item.currencyCodeReceiver;
export const isInternationalACHOnlyAvailableMethod = (item) => {
    const filtered = filterPaymentDeliveryOptions(item?.paymentMethodOptions, PaymentDeliveryMethodType.ANY);
    return filtered.length === 1 && filtered[0] === PaymentDeliveryMethodType.INTERNATIONAL;
};
